import React from 'react';

const EmailLink = () => <a href="mailto:support@behaviorguidance.com">support@behaviorguidance.com</a>

export default EmailLink;
